'use client';

import React from 'react';
import AimTrainerApp from '../components/AimTrainerApp';

export default function SimulatorPage() {
  return (
    <div className="relative w-full h-screen overflow-hidden">
      <AimTrainerApp />
    </div>
  );
}
